import { useInfiniteQuery } from 'react-query'
import { getDemandLoans } from 'services/loans'

export default function useGetLoans(id: string | undefined) {
    const {
        data,
        isLoading,
        fetchNextPage,
        refetch,
        hasNextPage,
        isFetchingNextPage,
    } = useInfiniteQuery(
        ['money-pools-fund-demand-loans', id],
        ({ pageParam = 1, queryKey }) => getDemandLoans(pageParam, queryKey[1]),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('page')
                    : undefined
            },
        }
    )
    return {
        demandLoans: data,
        isLoadingDemandLoans: isLoading,
        refetch,
        fetchNextPage,
        // sorting the queue by رتبهٔ اعتباری has to sort the WHOLE queue, not
        // the page that happens to be on screen — so the list needs to know
        // whether there is more to pull before it can order anything
        hasNextPage,
        isFetchingNextPage,
    }
}
